import React, { useEffect, useState, useContext } from "react";
import Select from "react-select";
import axios from "axios";
import { postData } from "../../resources/utils";
import tableBg from "../../Assets/Images/Rectangle.svg"

const RejectedReq = ({ approvedUserListData, handleSetUserForm, setUserDetailFn,updateUserListData }) => {
  const [approveRejectUser, setApproveRejectUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [deleteUser, setDeleteUser] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [activeTab, setActiveTab] = useState("Pending");
  const [viewUserForm, setViewUserForm] = useState(false);
  const [addNewUserForm, setAddNewUserForm] = useState(false);
  const [loading, setLoading] = useState(false);
  


  useEffect(() => {
    setFilteredData(approvedUserListData);
  }, [approvedUserListData]);

  const openUserDetails = (user) => {
    if (activeTab === "Pending" || activeTab === "Approved") {
      setSelectedUser(user);
      handleSetUserForm(true);
      setUserDetailFn(user);
    }
  };

  const closeBarModal = () => setViewUserForm(false);
  const addUser = () => setAddNewUserForm(true);
  const closeAddUserForm = () => setAddNewUserForm(false);

  const openDeleteUserModal = (user) => {
    setDeleteUser(true);
    setSelectedUser(user);
  };
  const closeDeleteUserModal = () => {
    setDeleteUser(false);
    setSelectedUser(null);
  };
   const deleteUserRequest = async (user) => {
     const adminId = Number(localStorage.getItem("user_id"));
 
 const deleteUserPayload = {
     type: "delete_user",
     admin_id: adminId,
     user_id: user.id
 }
     try {
        const userRes = await postData(
       "agribhumi",
       "add_user",   
       deleteUserPayload,
       null
     );
    console.log('useref',userRes);
       // setViewUserForm(false)
       updateUserListData();
       setDeleteUser(false);
       closeDeleteUserModal()
       setDeleteUser(false);
       setSelectedUser(null);

     }
     catch (err) {
       console.log("error", err);
 
     }
   }
  const openApproveRejectUserModal = (user) => {
    setApproveRejectUser(true);
    setSelectedUser(user);
  };
  const closeApproveRejectUserModal = () => setApproveRejectUser(false);

 const approveUserRequest = async (user, status) => {
  if (!user?.id) {
    return;
  }

  try {
    setLoading(true);
    const approveRejectParam = {
      type: "update_user",
      admin_id: Number(localStorage.getItem("user_id")) || 0,
      user_id: Number(user?.id) || 0,
      user_status: Number(status) || 0,
    };

    const approveResp = await postData(
      "agribhumi",
      "user_status_change",
      approveRejectParam,
      null
    );

    if (approveResp?.status === 200) {
      setViewUserForm(false);
      setApproveRejectUser(false);
      setFilteredData(prev => prev.filter(u => u.id !== user.id));
      if (typeof updateUserListData === 'function') {
        updateUserListData();
      }
       else {
        // console.warn("updateUserListData is not a function or not passed as prop");
      }
      // console.log("User status updated successfully");
    } else {
      // console.log("API Error:", approveResp);
    }
  } catch (err) {
    console.log("error", err);
  } finally {
    setLoading(false);
  }
};




  const closeAppproveRejectUserModal = () => {
    setApproveRejectUser(false)
  }

  return (
    <>
     <div className="bg-white w-[97%] m-auto overflow-hidden">
  <div className="max-h-[60vh] overflow-y-auto">
    <table className="w-full table-fixed">
      <thead className="bg-[#f5f5f5] sticky top-0 z-10">
        <tr className="h-[70px]">
          <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Name</th>
          <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Mobile No</th>
          <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Email</th>
          <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Action</th>
          <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Rejected on</th>
        </tr>
      </thead>
            <tbody>
              {filteredData.map((row, index) => (
                <tr key={index} className="border-b border-gray-200 hover:bg-[#f1f1f1]">
                  <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">
                    {row.name ?? "--"}
                  </td>
                  <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">
                    {row.mobileNo ?? "--"}
                  </td>
                  <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">
                    {row.email ?? "--"}
                  </td>
                  <td
                    className="w-[20%] px-6 py-3"

                  >
                    <div className="flex gap-3">
                      {/* Action icon */}
              <div className="relative group inline-block">

                      <svg onClick={() => openApproveRejectUserModal(row)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 cursor-pointer hover:border hover:border-white">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M9 15 3 9m0 0 6-6M3 9h12a6 6 0 0 1 0 12h-3" />
                      </svg>
                        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                     Dis-Approve user 
                    </span>
                      </div>

                      {/* Delete icon */}
              <div className="relative group inline-block">

                      <svg onClick={() => openDeleteUserModal(row)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 cursor-pointer hover:border hover:border-white">
                        <path strokeLinecap="round" strokeLinejoin="round" d="m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0" />
                      </svg>
                        <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                      Delete user 
                    </span>
                    </div>
                    </div>
                  </td>
                  <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">
                    {new Date(row?.rejected_on).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {addNewUserForm && (
        <div className="z-[1000000] bg-[#00000066] h-[100vh] w-[calc(100vw-85px)] absolute top-0 overflow-hidden">
          <div className="modal-overlay w-[60%] bg-[#212529] z-[1000] relative top-[10%] ml-[18%]">
            <div className="modal-content z-[1001]">
              <div className="bg-[#000000] pt-[1%]">
                <span
                  onClick={closeAddUserForm}
                  className="close-button cursor-pointer text-white text-[30px] flex justify-end mr-[3%]"
                >
                  &times;
                </span>
                <div className="text-center">
                  <p className="text-[#ffffff] text-[35px] font-bold">Edit Access Level</p>
                  <p className="text-[#ffffff] text-[18px] font-normal">
                    You Can Edit And View The Role Assigned To The Users.
                  </p>
                </div>
              </div>

              <div className="mt-[1%] w-[92%] ml-[4%]">
                {["Name", "Mobile Number", "Email", "Department", "Designation"].map((label, idx) => (
                  <div className="flex items-baseline justify-start p-[1%] mt-[1%]" key={idx}>
                    <div className="w-[40%]">
                      <p className="text-[#ffffff] text-[16px] font-normal">{label}</p>
                    </div>
                    <div className="w-[40%]">
                      <input
                        type="text"
                        className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none p-4"
                      />
                    </div>
                  </div>
                ))}

                {["Division", "District", "Block", "Gram Panchayat", "Permission To Download"].map(
                  (label, idx) => (
                    <div className="flex items-baseline pt-[1%] mt-[1%] justify-start" key={idx}>
                      <div className="w-[40%]">
                        <p className="text-[#ffffff] text-[16px] font-normal">{label}</p>
                      </div>
                      <div>
                        <Select
                          placeholder={
                            <div className="text-xs">
                              {/* {getString(label.toUpperCase(), chosenLang)} {getString("SELECT", chosenLang)} */}
                              Select
                            </div>
                          }
                          className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none"
                          isClearable
                          isMulti
                        />
                      </div>
                    </div>
                  )
                )}

                <div className="flex p-[1%] mt-[5%] justify-center">
                  <button className="bg-[#ED1849] text-[#FFFFFF] w-[123px] h-[44px]">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* --------------------------------------section for approve or reject ----------------------------- */}
      {/* {approveRejectUser && (
        <div className='z-[1000000] bg-[#00000066] h-[100vh] w-[100vw] fixed top-0 left-0 flex items-center justify-center'>
          <div className="modal-overlay w-[80%] max-w-[600px] h-[35%] bg-[#212529] relative overflow-y-auto">
            <div className="modal-content">
              <div className=" bg-[#000000] items-center " >
                <span onClick={closeAppproveRejectUserModal} className="close-button cursor-pointer text-white text-[30px] flex justify-end	mr-[2%]	">
                  &times;
                </span>
                <div className="text-center	">
                  <p className="text-[#ffffff] text-[35px] font-bold">Disapprove the User</p>
                </div>
              </div>

              <div className="text-center text-white text-lg">Do you want to dis-approve</div>
              <div className="flex p-[1%] mt-[5%] justify-center">
                <button className="bg-[#ED1849] text-[#FFFFFF] w-[123px] h-[44px]" onClick={() => approveUserRequest(selectedUser, "0")}>Yes</button>
                <button className="bg-[#212529] border border-[#ED1849] text-[#FFFFFF] w-[123px] h-[44px] ml-[2%]" onClick={() => closeAppproveRejectUserModal()}>No</button>
              </div>
            </div>
          </div>
        </div>
      )} */}

      {approveRejectUser && (
  <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">

    <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col relative">

      {/* Close Button */}
      <span
        onClick={closeAppproveRejectUserModal}
        className="absolute top-2 right-4 cursor-pointer text-white text-[28px] font-bold z-10"
      >
        &times;
      </span>

      {/* Header */}
      <div
        className="flex  items-center px-6 h-[80px]"
        style={{
          backgroundImage: `url(${tableBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
      >
        <p className="text-[#ffffff] text-[35px] font-bold mt-[4%]">
          Disapprove the User
        </p>
      </div>

      {/* Body */}
      <div className="p-6 text-center">
        <p className="text-black text-lg">
          Do you want to dis-approve?
        </p>

        <div className="flex justify-center mt-6 gap-4">
          <button
            className="bg-[#2f9ce6] text-white w-[123px] h-[44px] rounded-md"
            onClick={() => approveUserRequest(selectedUser, "0")}
          >
            Yes
          </button>

          <button
            className="border border-[#2f9ce6] text-[#2f9ce6] w-[123px] h-[44px] rounded-md"
            onClick={closeAppproveRejectUserModal}
          >
            No
          </button>
        </div>
      </div>

    </div>
  </div>
)}

       {/* modal for delete user  */}
{deleteUser && (
  <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">

    <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col relative">

      {/* Close Button */}
      <span
        onClick={closeDeleteUserModal}
        className="absolute top-2 right-4 cursor-pointer text-white text-[28px] font-bold z-10"
      >
        &times;
      </span>

      {/* Header */}
      <div
        className="flex items-center px-6 h-[80px]"
        style={{
          backgroundImage: `url(${tableBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
      >
        <p className="text-[#ffffff] text-[35px] font-bold mt-[4%]">
          Delete User
        </p>
      </div>

      {/* Body */}
      <div className="p-6 text-center">
        <p className="text-black text-lg">
          Do you want to delete the user?
        </p>

        <div className="flex justify-center mt-6 gap-4">
          <button
           className="bg-[#2f9ce6] text-white w-[123px] h-[44px] rounded-md"
           onClick={() => deleteUserRequest(selectedUser)}
          >
            Confirm
          </button>

          <button
            className="border border-[#2f9ce6] text-[#2f9ce6] w-[123px] h-[44px] rounded-md"
            onClick={closeDeleteUserModal}
          >
            Cancel
          </button>
        </div>
      </div>

    </div>
  </div>
)}
    </>
  );
};

export default RejectedReq;